<template>
    <div>
      <!-- 面包屑 begin -->
      <eup-crumbs icon="Money" firstCrumbs="资金管理" secondCrumbs="充值记录" />
      <!-- 面包屑 end -->
      <!-- 内容区域 begin -->
      <div class="container">
          <div class="handle-box">
            <el-form ref="state.query" :model="state.query" :inline="true" v-if="checkPermission([`api${state.VIEW_VERSION}:fund:fund:getrechargepage`])">
              <el-form-item label="用户名">
                <el-select 
                  v-model="state.query.userId" 
                  filterable 
                  placeholder="请选择"
                  :filter-method="filterHandle"
                  :clearable="true"
                   class="handle-select mr10"
                  >
                  <el-option
                    v-for="item in state.options"
                    :key="item.value"
                    :label="item.label"
                    :value="item.value">
                  </el-option>
                </el-select>
              </el-form-item>
              <el-form-item label="商户充值单号">
                <el-input v-model="state.query.rechargeOutTradeNo" placeholder="商户充值单号" ></el-input>
              </el-form-item>
              <!-- <el-form-item label="交易开始时间">
                <el-date-picker v-model="state.query.startDate" type="date" placeholder="选择日期" :disabledDate="disabledDate1">
                </el-date-picker>
              </el-form-item>
              <el-form-item label="交易结束时间">
                <el-date-picker v-model="state.query.endDate" type="date" placeholder="选择日期" :disabledDate="disabledDate2">
                </el-date-picker>
              </el-form-item> -->
              <el-form-item label="时间选择">
                <el-date-picker
                  v-model="state.time"
                  type="datetimerange"
                  range-separator="至"
                  start-placeholder="开始日期"
                  end-placeholder="结束日期">
                </el-date-picker>
              </el-form-item>
              <el-form-item>
              <el-button type="primary" icon="Search" @click="handleSearch">搜索</el-button>
              </el-form-item>
            </el-form>
          </div>
          <el-table
              :data="state.tableData"
              border
              highlight-current-row
              class="table"
              ref="multipleTable"
              header-cell-class-name="table-header"
              @selection-change="handleSelectionChange"
              v-loading="state.loading"
              >
              <el-table-column prop="num" label="序号" width="60" align="center"></el-table-column>
              <el-table-column prop="rechargeOrderNo" label="充值单号" align="center" min-width="180px"></el-table-column>
              <el-table-column prop="rechargeOutTradeNo" label="商户充值单号" align="center" min-width="180px"></el-table-column>
              <el-table-column prop="rechargeAmount" label="充值金额" min-width="120" align="center"></el-table-column>
              <el-table-column prop="giveAmount" label="赠送金额" min-width="120" align="center"></el-table-column>
              <el-table-column prop="rechargeStatus" label="充值状态" min-width="100" align="center" :formatter="rechargeStatusFormat"></el-table-column>
              <el-table-column prop="actualArrivalAmount" label="到账金额" min-width="120" align="center"></el-table-column>
              <el-table-column label="操作" min-width="180" align="center" fixed="right">
                <template #default="scope">
                    <el-button
                        type="text"
                        icon="Check"
                        @click="handleClickDetails(scope.row)"
                    >查看详情</el-button>
                </template>
              </el-table-column>
          </el-table>
            <!-- 分页 begin -->
            <EupPagination
                :current-page="state.pageIndex"
                :pagesizes="[10,20,50,100]"
                :pagesize="state.pageSize"
                :total="state.pageTotal"
                @getPageData="getData"
                @resPageData="resPageData">
            </EupPagination>
            <!-- 分页 begin -->
      </div>
      <!-- 内容区域 begin -->
      <!-- 详情窗口 begin -->
      <el-dialog 
        title="充值详情" 
        v-model="state.detailsVisible"
        width="70%"
        >
        <div class="home-container">
        <el-form
          :model="state.detailsForm"
          label-width="80px"
          :inline="false"
          >
          <el-row>
            <el-col :xs="24" :sm="24" :md="12" :lg="8" :xl="6">
              <el-form-item label="充值单号：" prop="rechargeOrderNo"  label-width="100px">
                   <input v-model="state.detailsForm.rechargeOrderNo" class="inputin" :disabled="true" />   
                  </el-form-item>
              </el-col>
            <el-col :xs="24" :sm="24" :md="12" :lg="8" :xl="6">
                  <el-form-item label="商户充值单号：" prop="rechargeOutTradeNo"  label-width="100px">
                   <input v-model="state.detailsForm.rechargeOutTradeNo" class="inputin" :disabled="true" />   
                  </el-form-item>
              </el-col>
            <el-col :xs="24" :sm="24" :md="12" :lg="8" :xl="6">
                  <el-form-item label="充值金额：" prop="rechargeAmount"  label-width="100px">
                   <input v-model="state.detailsForm.rechargeAmount" class="inputin" :disabled="true" />   
                  </el-form-item>
              </el-col>
            <el-col :xs="24" :sm="24" :md="12" :lg="8" :xl="6">
                  <el-form-item label="赠送金额：" prop="giveAmount"  label-width="100px">
                   <input v-model="state.detailsForm.giveAmount" class="inputin" :disabled="true" />   
                  </el-form-item>
              </el-col>
                          <el-col :xs="24" :sm="24" :md="12" :lg="8" :xl="6">
                  <el-form-item label="到账金额：" prop="actualArrivalAmount"  label-width="100px">
                   <input v-model="state.detailsForm.actualArrivalAmount" class="inputin" :disabled="true" />   
                  </el-form-item>
              </el-col>
                          <el-col :xs="24" :sm="24" :md="12" :lg="8" :xl="6">
                  <el-form-item label="充值状态：" prop="rechargeStatus"  label-width="100px">
                   <input v-model="state.detailsForm.rechargeStatus" class="inputin" :disabled="true" />   
                  </el-form-item>
              </el-col>
                          <el-col :xs="24" :sm="24" :md="12" :lg="8" :xl="6">
                  <el-form-item label="备注：" prop="remark"  label-width="100px">
                   <input v-model="state.detailsForm.remark" class="inputin" :disabled="true" />   
                  </el-form-item>
              </el-col>
          </el-row>
        </el-form>
  </div>
      </el-dialog>
      <!-- 详情窗口 end -->
    </div>
</template>
<script>
import {reactive,onMounted,ref} from "vue"
import { ElMessage } from 'element-plus'
import { GetRechargePage} from "@/serviceApi/fund/recharge";
import { GetSelectList} from "@/serviceApi/user/userList";
import EupPagination from "../../../components/EupPagination.vue"
import EupCrumbs from "../../../components/eup-crumbs/index.vue"
import EnumConfig from "@/enum/EnumConfig"
import { elConfirmDialog, formatDate,returnFloat, IsNullOrEmpty } from "@/common/js/comm";

var CURR_VIEW_VERSION = EnumConfig.EnumConfig.API_VIEW_VERSION.CURR_API_VIEW_VERSION;
var VIEW_VERSION = CURR_VIEW_VERSION == 'V0' ? '' : `:S:${CURR_VIEW_VERSION}`;

export default {
    name: "Recharge",
    components: {
        EupPagination: EupPagination,
        EupCrumbs: EupCrumbs
    },
    setup(){
        const state = reactive({
          VIEW_VERSION: VIEW_VERSION,
            query: {
              "userId": "",
              "rechargeOutTradeNo": "",
            },
            time: "",
            pageIndex: 1,
            pageSize: 10,
            tableData: [],
            multipleSelection: [],
            pageTotal: 0,
            detailsForm: {},
            dynamicFilter:{},
            loading: false,
            detailsVisible: false,
            options: [],//用户下拉
            rechargeStatus:[
              {value: 0, label:"全部"},
              {value: 1, label:"待支付"},
              {value: 2, label:"已支付"},
              {value: 3, label:"已关闭"}
            ]
        });
        onMounted(()=>{
          // getData();
        })
        //获取表单信息
        const getData=()=>{
          var sttime = "";
          var entime = "";
          if (state.time == null) {
          } else {
            sttime = formatDate(state.time[0]);
            entime = formatDate(state.time[1]);
          }
          if (sttime == "NaN-NaN-NaN NaN:NaN:NaN") {
            sttime = "";
          }
          if (entime == "NaN-NaN-NaN NaN:NaN:NaN") {
            entime = "";
          }
            var params = {
                "currentPage": state.pageIndex,
                "pageSize": state.pageSize,
                "filter.userId": state.query.userId,
               "filter.rechargeOutTradeNo": state.query.rechargeOutTradeNo,
               "filter.startDate": sttime,
               "filter.endDate": entime,
                "dynamicFilter": state.dynamicFilter
            }
            if (state.query.userId == ""){
              ElMessage.warning("请选择要查询的用户！");
              return;
            }
            state.loading = true;
            GetRechargePage(params).then(function(res){
                if(res.code == 1){
                state.pageTotal = res.data.total;//初始化列表数据总数
                state.tableData = res.data.list;
                //添加num序号字段
                state.tableData.forEach((data, i) => {
                    data.num = i + 1;
                });
                } else {
                ElMessage.error(res.msg);   
                }
                state.loading = false;
            });
        }
        // 多选操作
       const handleSelectionChange =(val)=> {
            state.multipleSelection = val;
        }
        // 触发搜索按钮
        const handleSearch=()=> {
            state.pageIndex = 1
            getData();
        }

        //充值状态文本格式化
        const rechargeStatusFormat = ((row) =>{
          let resp = "";
          state.rechargeStatus.forEach(item =>{
            if (row.rechargeStatus==item.value && row.rechargeStatus != 0) {
              resp = item.label;
              return false;
            }
          });
          return resp;
        });
        //详情
        const handleClickDetails = ((row) =>{
          state.detailsVisible  = true;
          let strJson = JSON.stringify(row);
          state.detailsForm = JSON.parse(strJson);

          //充值状态
          let rechargeStatus = "";
          state.rechargeStatus.forEach(item=>{
            if (row.rechargeStatus == item.value && row.rechargeStatus != 0){
              rechargeStatus = item.label;
              return false;
            }
          });
          state.detailsForm.rechargeStatus=rechargeStatus;
        });
        //交易日期选择范围
        const disabledDate1= (time) => {
          if (state.query.endDate != "" && state.query.endDate != null && state.query.endDate != undefined) {
            return time.getTime() > state.query.endDate;
          } 
          return time.getTime() > Date.now();
        }
        const disabledDate2= (time) => {
          if (state.query.startDate != "" && state.query.startDate != null && state.query.startDate != undefined){
            return time.getTime() < state.query.startDate || time.getTime() > Date.now();
          }
          return time.getTime() > Date.now();
        }
        //模糊查询api
        const filterHandle = ((value)=>{
          let params = {
            userName: value
          }
          if (params.userName.trim() == ""){
            state.options = [];
            return;
          }          
          if (state.timeoutId){
            clearTimeout(state.timeoutId);
            state.timeoutId = null;
          }
          state.timeoutId = setTimeout(()=>{
            GetSelectList(params).then(function(res){
              if(res.code == 1){
                state.options = [];
                if (res.data.length > 0){
                  res.data.forEach((item)=>{
                    state.options.push({
                      value: item.userId,
                      label: item.userName
                    });
                  });
                }
              } else {
                ElMessage.error(res.msg);   
              }
              state.loading = false;
            });
          }, 500);
        });

        /**
         * @description 子组件返回分页数据
         * @author weig
         * @param {Object} obj
         */
        const resPageData = (obj) =>{
            state.pageIndex = obj.currPage;
            state.pageSize = obj.pageSize;
        }
        return {
            state,
            handleSelectionChange,
            handleSearch,
            handleClickDetails,
            disabledDate1,   
            disabledDate2,  
            filterHandle,
            rechargeStatusFormat,
            getData,
            resPageData
        }
    }
};
</script>
<style scoped>
</style>

